module.exports = __webpack_public_path__ + "media/images/dot-9a1e4da4b83041d3707601c2c68989a8.png";